import { Block, Footer, Typography } from '@xprog/prensa'
import ClickableAsset from 'components/ClickableAsset/ClickableAsset.index'
import { useIcon } from 'hooks/useIcon'
import { AssetsContext } from 'providers/Assets'
import React, { useContext, useEffect } from 'react'

import { FooterProps } from './Footer.types'


const FooterComponent: React.FC<FooterProps> = () => {
  const assetsContext = useContext(AssetsContext)
  const { css, data } = assetsContext.assets.footer
  const icons = useIcon(data.socialNetworks.map((i) => i.icon))
  const textStyle = {
    color: '$basicWhite',
    fontFamily: '$primary',
    fontSize: '$paragraphPaywall',
    fontWeight: '$paragraphPaywall',
    lineHeight: '$paragraphPaywall',
  }

  useEffect(() => {
    let tp = window.tp || []
    tp?.experience?.execute()
  })

  const SlotMiddle = () => (
    <Block
      css={{
        align: ['column', 'center', 'middle'],
        width: '100%',
        '@xl': {
          align: ['row', 'between', 'middle'],
          maxWidth: '1280px'
        }
      }}
    >
      <Block
        css={{
          align: ['column', 'center', 'middle'],
          '@xl': { align: ['row', 'left', 'middle'] }
        }}
      >
        <Typography
          as='span'
          css={{
            ...textStyle,
            mb: '$4',
            '@xl': { mb: '$0' }
          }}
        >
          {data.leftText}
        </Typography>
        <Block
          css={{
            align: ['row', 'left', 'middle'],
            mx: '$2',
            'a': { m: '$1' }
          }}
        >
          {data.socialNetworks.map((i, k) => (
            <ClickableAsset
              key={i.id}
              alt={i.title}
              src={icons[k].url}
              href={i.href}
              target={i.target}
              height=''
              width=''
            />
          ))}
        </Block>
      </Block>
      <Block
        css={{
          align: ['column', 'center', 'middle'],
          'a': { m: '$4' },
          '@xl': { align: ['row', 'left', 'middle'] }
        }}
      >
        {data.navMenu.map((i) => (
          <a key={i.id} href={i.href} target={i.target}>
            <Typography
              as='span'
              css={textStyle}
            >
              {i.title}
            </Typography>
          </a>
        ))}
      </Block>
      <Typography
        as='span'
        css={{
          ...textStyle,
          display: 'none',
          '@xl': { display: 'flex' }
        }}
      >
        {data.rightText}
      </Typography>
    </Block>
  )

  const SlotBottom = () => (
    <Typography
      as='span'
      css={{
        ...textStyle,
        display: 'flex',
        '@xl': { display: 'none' }
      }}
    >
      {data.rightText}
    </Typography>
  )

  return (
    <Footer
      slotMiddle={SlotMiddle}
      slotBottom={SlotBottom}
      css={css}
    />
  )
}

export default FooterComponent
